(function () {
  function isMobileSlider() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function isSliderActive(section) {
    return isMobileSlider() || section.hasAttribute('data-meeoow-desktop-slider');
  }

  function isDesktopSlider(section) {
    return section.hasAttribute('data-meeoow-desktop-slider') && !isMobileSlider();
  }

  function getSlideStep(track) {
    var slide = track.querySelector('.slider_block_ee');
    if (!slide) {
      return 0;
    }
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.offsetWidth + gap;
  }

  function getActiveIndex(track, slides) {
    var scrollLeft = track.scrollLeft;
    var activeIndex = 0;
    var minDiff = Infinity;

    slides.forEach(function (slide, index) {
      var diff = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function initMeeoowSlider(section) {
    if (!section || section.dataset.meeoowSliderInit === 'true') {
      return;
    }

    var track = section.querySelector('[data-meeoow-slider-track]');
    if (!track) {
      return;
    }

    var slides = track.querySelectorAll('.slider_block_ee');
    var dotsWrap = section.querySelector('[data-meeoow-slider-dots]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-meeoow-slider-dot]') : [];
    var prevBtn = section.querySelector('[data-meeoow-slider-prev]');
    var nextBtn = section.querySelector('[data-meeoow-slider-next]');

    section.dataset.meeoowSliderInit = 'true';

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function goToSlide(index) {
      var slide = slides[index];
      if (!slide || !isSliderActive(section)) {
        return;
      }

      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      setActiveDot(index);
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn || !isDesktopSlider(section)) {
        return;
      }

      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      var step = getSlideStep(track);
      if (!step || !isDesktopSlider(section)) {
        return;
      }

      track.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goToSlide(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (isSliderActive(section) && dots.length) {
          setActiveDot(getActiveIndex(track, slides));
        }
        updateArrows();
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (!isSliderActive(section)) {
        track.scrollLeft = 0;
        setActiveDot(0);
      }
      updateArrows();
    });

    updateArrows();
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-meeoow-slider]').forEach(initMeeoowSlider);
  }

  window.MeeoowSlider = {
    init: boot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    }, { once: true });
  } else {
    boot();
  }
})();
